import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Duży czerwony banner: świeżo utworzone zapotrzebowanie jest tylko szkicem —
 * trzeba je jeszcze sprawdzić i zaakceptować w zakładce „Zapotrzebowania usług
 * zewnętrznych”, inaczej nie stanie się zamówieniem i nie trafi do podwykonawcy.
 * Jeden komponent, bo ten sam komunikat pokazujemy w kilku miejscach (lista po
 * utworzeniu, kreator WPW, przekazanie pakietu WNU podwykonawcy).
 */
export function RequisitionApprovalNotice({ withLink = false }: { withLink?: boolean }) {
  return (
    <div
      role="alert"
      className="flex items-start gap-3 border-2 border-red-500 bg-red-50 p-4 text-red-800 dark:border-red-700 dark:bg-red-950/30 dark:text-red-300"
    >
      <AlertTriangle size={22} className="mt-0.5 shrink-0" />
      <div className="text-sm font-semibold">
        Po utworzeniu zapotrzebowania należy je sprawdzić i zaakceptować w zakładce
        {" "}„Zapotrzebowania usług zewnętrznych” — bez akceptacji nie stanie się
        zamówieniem i nie trafi do podwykonawcy.
        {withLink && (
          <>
            {" "}
            <Link to="/requisitions" className="underline hover:no-underline">
              Przejdź do zapotrzebowań →
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
